export default {
  filters: {
    fullAddress(address) {
      return `${address.street}, ${address.street_number} ${
        address.complement
      } ${address.district.display_name} - ${
        address.district.city.display_name
      }/${address.district.city.state.code.toUpperCase()}`;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/addressMixin.js